import { coordinates } from "./coordinates"
import { validationRules } from "./validationRules"
import { toiSignedMandatory } from "./toiSignedMandatory"
import { abnormalityRestriction } from "./abnormalityRestrictionValidator"
import { serviceTypePermission } from "./serviceTypePermission"
import { sealValidator } from "./sealsValidator"
import { reasonForNotSigning } from "./reasonForNotSigningValidator"
import { readingRoute } from "./readingRoute"
import { requiredIfCustom } from "./requireIfCustom"

export default {
  coordinates,
  validationRules,
  serviceTypePermission,
  toiSignedMandatory,
  requiredIfCustom,
  abnormalityRestriction,
  sealValidator,
  reasonForNotSigning,
  readingRoute,
}
